import { render } from "./attachmentUploader.vue?vue&type=template&id=0946d5be&ts=true"
import script from "./attachmentUploader.vue?vue&type=script&lang=ts"
export * from "./attachmentUploader.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__